var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-button',{style:(_vm.loginStyle),attrs:{"type":"info","weixin:":""},on:{"click":_vm.signInwx}},[_vm._v("点击分享")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }